import * as React from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import { Card, CardContent } from '@/components/ui/card'

export function ProfileSkeleton() {
    return (
        <div className="flex flex-col gap-4">
            {/* Main Card */}
            <Card className="border-none shadow-none rounded-lg">
                <CardContent className="flex flex-col gap-4">
                    <Skeleton
                        className="mb-2 rounded-lg"
                        style={{ height: '4em' }}
                    />
                    <Skeleton
                        className="mb-2 rounded-lg"
                        style={{ height: '5em' }}
                    />
                </CardContent>
            </Card>

            {/* Block 1: HeatMap placeholder */}
            <div>
                <Skeleton
                    className="mb-2 rounded-lg"
                    style={{ height: '8em' }}
                />
            </div>

            {/* Block 2: Programmes Stack placeholder */}
            <div className="flex flex-col gap-4">
                <Skeleton
                    className="mb-2 rounded-lg"
                    style={{ height: '5em' }}
                />
                <Skeleton
                    className="mb-2 rounded-lg"
                    style={{ height: '3em' }}
                />
                <Skeleton
                    className="mb-2 rounded-lg"
                    style={{ height: '5em' }}
                />
                <Skeleton
                    className="mb-2 rounded-lg"
                    style={{ height: '1em' }}
                />
            </div>
        </div>
    )
}
